// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';
import {DbsLabels} from '../dbs-customer-profile/dbs-labels';
import {Customer} from '../customer';
import {DataShareApplicationStatus} from './data-share-application-status';
import {PageStatus} from '../page-status';

export const DataShare = t.struct({
    customer: Customer,
    labels: DbsLabels,
    dataShareApplicationStatus: DataShareApplicationStatus
}, {
    defaultProps: {
        customer: new Customer({}),
        labels: new DbsLabels({}),
        dataShareApplicationStatus: new DataShareApplicationStatus({})
    },
    name: 'DataShare',
    strict: true
});

const isDataSharePageLoaded = (dataShareApplicationStatus) => dataShareApplicationStatus.dataSharePageStatus !== PageStatus.meta.map.ERROR;

const checkIfAllEnabledAndRequiredFieldsAreFilledForAddress = (address) => {
    const {addressElements} = address.addressComponent;
    const listOfRequireElements = Object.keys(addressElements).reduce((requireElement, elementKey) => {
        if (addressElements[elementKey].enabled && addressElements[elementKey].required) {
            requireElement.push(elementKey);
        }

        return requireElement;
    }, []);

    return listOfRequireElements.length === 0 || listOfRequireElements.every((field) => address[field]);
};

const checkAddressState = ({communication}) => {
    const {
        mailingAddress,
        physicalAddress
    } = communication;
    const isMailingAddressInteracted = mailingAddress.canCompareAddressSectionBeReset();
    const isPhysicalAddressInteracted = physicalAddress.canCompareAddressSectionBeReset();
    const isMailingAddressComplete = checkIfAllEnabledAndRequiredFieldsAreFilledForAddress(communication.mailingAddress);
    const isPhysicalAddressComplete = checkIfAllEnabledAndRequiredFieldsAreFilledForAddress(communication.physicalAddress);
    const bothAddressTypesFilled = (addressOneStatus, addressTwoStatus) => addressOneStatus && addressTwoStatus;
    const onlyOneAddressFilled = (addressOneStatus, addressTwoStatus) => addressOneStatus && !addressTwoStatus;

    return [
        bothAddressTypesFilled(isPhysicalAddressComplete, isMailingAddressComplete),
        onlyOneAddressFilled(isPhysicalAddressComplete, isMailingAddressInteracted),
        onlyOneAddressFilled(isMailingAddressComplete, isPhysicalAddressInteracted)
    ].some((condition) => condition);
};

DataShare.prototype.isDataShareSaveButtonEnabled = function () {
    return [
        isDataSharePageLoaded(this.dataShareApplicationStatus),
        checkAddressState(this.customer),
        this.customer.isEmailValidForSave()
    ].every((condition) => condition);
};
